import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
}

function Badge({ children }:Props) {
  return (
        <div className={styles.wrapper}
             aria-label='badge' >
            <Text color={colors.gray6}
                  className={styles.text}
                  fontWeight='bold' >
                {children}
            </Text>
        </div>
  );
}

function BadgeContainer({ children, position }:{children?: ReactNode, position: 'LEFT' | 'RIGHT'}) {
  return (
        <Container position={position}>
            {children}
        </Container>
  );
}

const Container = styled.div<{
    position: 'LEFT' | 'RIGHT';
}>`
    position: absolute;
    right: ${(props) => (props.position === 'RIGHT' ? '-8px' : 'unset')};
    left: ${(props) => (props.position === 'LEFT' ? '-8px' : 'unset')};
    top: -8px;
    display: flex;
    flex-direction: column;
    align-items: ${(props) => (props.position === 'RIGHT' ? 'flex-end' : 'flex-start')};
    row-gap: 6px;
`;

Badge.Container = BadgeContainer;

export default Badge;
